import { FC, memo, useCallback, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import { useSelector } from 'react-redux'
import { useAppDispatch } from '../../../../../redux/hooks'
import { filterSubmit, getObjectCount } from '../../../../../redux/filters'
import { ButtonText, Container, SubmitButton } from './styles'
import { FilterSectionTransport } from '../../../../../transports/search-result-listing-static-transport'
import { stopPropagation } from '../../../../../utils/dom-utils'

type Props = {
    filterStaticData: FilterSectionTransport
    handleModalToggle: () => void
}

const FilterModalFooter: FC<Props> = ({ filterStaticData, handleModalToggle }) => {
    const dispatch = useAppDispatch()
    const objectCount = useSelector(getObjectCount)
    const theme = useContext(ThemeContext)

    const handleFilterSubmit = useCallback(() => {
        dispatch(filterSubmit())
        handleModalToggle()
    }, [dispatch, handleModalToggle])

    return (
        <Container onMouseDown={stopPropagation}>
            <SubmitButton
                padding={`${theme?.spacing.xSmall} 0`}
                onClick={handleFilterSubmit}
                disabled={objectCount < 1}
            >
                <ButtonText>{`${filterStaticData.show} ${objectCount} ${filterStaticData.properties}`}</ButtonText>
            </SubmitButton>
        </Container>
    )
}

export default memo(FilterModalFooter)
